/**
 * Safe localStorage wrapper.
 * Falls back to an in-memory store in SSR / environments without localStorage.
 */

const memStore: Record<string, string> = {};

function isStorageAvailable(): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  } catch {
    return false;
  }
}

export const storage = {
  get(key: string): string | null {
    if (isStorageAvailable()) {
      return window.localStorage.getItem(key);
    }
    return memStore[key] ?? null;
  },
  set(key: string, value: string): void {
    if (isStorageAvailable()) {
      window.localStorage.setItem(key, value);
    } else {
      memStore[key] = value;
    }
  },
  remove(key: string): void {
    if (isStorageAvailable()) {
      window.localStorage.removeItem(key);
    } else {
      delete memStore[key];
    }
  },
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'trystyle_access_token',
  REFRESH_TOKEN: 'trystyle_refresh_token',
  PLATFORM_TOKEN: 'trystyle_platform_token',
  PLATFORM_TOKEN_EXPIRY: 'trystyle_platform_token_expiry',
  PLATFORM_SDK_CONFIG: 'trystyle_platform_sdk_config',
  USER: 'trystyle_user',
  DEVICE_ID: 'trystyle_device_id',
  DEVICE_FINGERPRINT: 'trystyle_device_fingerprint',
  /** Height entered in the pre-upload height dialog (inches) */
  USER_HEIGHT_IN: 'trystyle_user_height_in',
  /** Latest avatar upload response (avatarId + size recommendation) for after-tryon display */
  AVATAR_CACHE: 'trystyle_avatar_cache',
} as const;
